export default __webpack_public_path__ + "static/case-study-3-0307fdb94225efe3671996bf043df070.webp";